"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("../../../Button"));
var props_1 = require("../../context/props");
var SubmitButton = function () {
    var _a = (0, props_1.usePropsContext)(), translate = _a.translate, isLoading = _a.isLoading;
    return (react_1.default.createElement(Button_1.default, { type: "submit", fullWidth: true, color: "primary", isLoading: isLoading }, translate('feedbackModal.send')));
};
exports.default = SubmitButton;
